import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LenisProvider from "@/components/LenisProvider";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MarqueeBand from "@/components/MarqueeBand";
import WhyNow from "@/components/WhyNow";
import SpiPsyModel from "@/components/SpiPsyModel";
import InnerCompass from "@/components/InnerCompass";
import Founders from "@/components/Founders";
import Assessment from "@/components/Assessment";
import Schedule from "@/components/Schedule";
import Fees from "@/components/Fees";
import EnrollCTA from "@/components/EnrollCTA";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

const Home = () => (
  <main className="App grain" data-testid="home-root">
    <Nav />
    <Hero />
    <MarqueeBand />
    <WhyNow />
    <SpiPsyModel />
    <InnerCompass />
    <Founders />
    <Assessment />
    <Schedule />
    <Fees />
    <EnrollCTA />
    <Footer />
    <WhatsAppButton />
  </main>
);

function App() {
  return (
    <LenisProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </LenisProvider>
  );
}

export default App;
